import React from "react";

const PrivateGPFeesCheckListContent = {
  checklistText: (
    <React.Fragment>
      <p>
        Private GP fees cash benefit is not available on all plans. Please check
        your handbook to see if you have cover.
      </p>
      <p>Before you start, please have the following ready:</p>
    </React.Fragment>
  ),
  checklist: ["Invoices, receipts for your appointment"],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const PrivateGPFees = {
  HOL: {
    ...PrivateGPFeesCheckListContent,
    checklistText: (
      <React.Fragment>
        <p>
          Private GP fees cash benefit is not available on all policies. Please
          check your handbook to see if you have cover.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Any: PrivateGPFeesCheckListContent
};

export default PrivateGPFees;
